import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from '~/plugins/axios';

import SearchModuleSessionOfDay from '~/components/dashboard/SearchModuleSessionOfDay';
import Register from '~/components/Register.vue';

export default {
  name: "initPortalBeforeProduction",
  components: {
    SearchModuleSessionOfDay: SearchModuleSessionOfDay,
    Register: Register
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    console.log('\n\n ====== this is initPortal ======\n', this.$route.path, '\n ------------------');
  },

  methods: {
    testing: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var count;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.post('/initPortal/testing', {});

              case 2:
                count = _context.sent.data.count;

                // let count = 123;
                alert(count);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testing() {
        return _ref.apply(this, arguments);
      }

      return testing;
    }(),
    addModuleSession: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _data, errors, count;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return axios.post('/initPortal/moduleSession');

              case 2:
                _data = _context2.sent.data;
                errors = _data.errors;
                count = _data.count;


                console.log('\n\n ====== initPortal <|-- module session errors ====== \n', errors, '\n ----------------');

                console.log('\n\n ====== initPortal <|-- module session count ====== \n', count, '\n ----------------');

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addModuleSession() {
        return _ref2.apply(this, arguments);
      }

      return addModuleSession;
    }(),
    createUser: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(userRegisterInfo) {
        var superUserInfo;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('\n\n ====== initPortal <|-- userRegisterInfo ====== \n', userRegisterInfo, '\n ----------------');

                _context3.next = 3;
                return axios.post('/initPortal/createSuperUser', userRegisterInfo);

              case 3:
                superUserInfo = _context3.sent.data;


                console.log('\n\n ====== initPortal <|-- userRegisterInfo ====== \n', superUserInfo, '\n ---------------');

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createUser(_x) {
        return _ref3.apply(this, arguments);
      }

      return createUser;
    }(),
    createUserDB: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var info;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return axios.post('/initPortal/migrateUsersDb', { hey: 'hey' });

              case 2:
                info = _context4.sent.data;


                console.log(info);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createUserDB() {
        return _ref4.apply(this, arguments);
      }

      return createUserDB;
    }(),
    updateUserMsStatus: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var infoReturned;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return axios.post('/initPortal/migrateGenerateMsStatus', {});

              case 2:
                infoReturned = _context5.sent.data;

                console.log('infoReturned is ', infoReturned);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateUserMsStatus() {
        return _ref5.apply(this, arguments);
      }

      return updateUserMsStatus;
    }(),
    withoutWorkingProfile: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var infoReturn;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('withoutWorkingProfile');
                _context6.next = 3;
                return axios.get('initPortal_2/withoutWorkingProfile/');

              case 3:
                infoReturn = _context6.sent.data;

                console.log('total num is ', infoReturn);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function withoutWorkingProfile() {
        return _ref6.apply(this, arguments);
      }

      return withoutWorkingProfile;
    }(),
    withWorkingProfile: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var infoReturn;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('withWorkingProfile');

                _context7.next = 3;
                return axios.get('initPortal_2/withWorkingProfile/');

              case 3:
                infoReturn = _context7.sent.data;


                console.log('info returned ', infoReturn);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function withWorkingProfile() {
        return _ref7.apply(this, arguments);
      }

      return withWorkingProfile;
    }(),
    updateFiles: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var infoReturn;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('updateFiles');

                _context8.next = 3;
                return axios.get('/initPortal_2/migrateUpdateFiles', {});

              case 3:
                infoReturn = _context8.sent.data;


                console.log('info returned ', infoReturn);

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function updateFiles() {
        return _ref8.apply(this, arguments);
      }

      return updateFiles;
    }(),
    holdNricFin: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var infoReturn;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log('hold nric fin');

                _context9.next = 3;
                return axios.get('/initPortal_2/holdNricFin', {});

              case 3:
                infoReturn = _context9.sent.data;


                console.log(infoReturn);

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function holdNricFin() {
        return _ref9.apply(this, arguments);
      }

      return holdNricFin;
    }(),
    holdUsername: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var infoReturn;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                console.log('hold nric fin');

                _context10.next = 3;
                return axios.get('/initPortal_2/holdUsername', {});

              case 3:
                infoReturn = _context10.sent.data;


                console.log(infoReturn);

              case 5:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function holdUsername() {
        return _ref10.apply(this, arguments);
      }

      return holdUsername;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/initPortalBeforeProduction.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/initPortalBeforeProduction.vue
// module chunks = 10